import { useTranslation } from 'react-i18next';

import { ButtonGroupField, type ButtonGroupFieldProps } from '../../fields/ButtonGroupField';
import type { FormIncidentsFilter } from '../lib/types';

type TypeDateFieldProps = Omit<
  ButtonGroupFieldProps<FormIncidentsFilter, 'typeDate'>,
  'name' | 'exclusive' | 'options'
>;

export const TypeDateField = (props: TypeDateFieldProps) => {
  const { t } = useTranslation();

  return (
    <ButtonGroupField
      {...props}
      name='typeDate'
      exclusive
      options={[
        { value: 'registeredDate', children: t('registered-date') },
        { value: 'resolvedDate', children: t('resolved-date') },
        { value: 'endDatetime', children: t('end-datetime') },
      ]}
    />
  );
};
